import React from "react"
import { TopHeaderMenu } from "../components/TopHeaderMenu"
import { BottomTabBar } from "../components/BottomTabBar"
import { Outlet } from "react-router-dom"

export default function Layout() {
    return (
        <div className="front">
            <TopHeaderMenu />
            <div className="pageContent">
                <Outlet />
            </div>
            <footer className="sideFooter">
                <a href="/personvern.html">Personvern</a>
                <a href="/vilkar.html">Vilkår</a>
            </footer>
            <BottomTabBar />
        </div>
    )
}
